import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Home } from 'lucide-react';
export interface BreadcrumbItem {
  label: string;
  to?: string;
}
interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}
export function Breadcrumbs({
  items
}: BreadcrumbsProps) {
  // Always start with Home
  const allItems = [{
    label: 'Home',
    to: '/'
  }, ...items];
  return <nav aria-label="Breadcrumb" className="bg-slate-50 border-b border-steel-200 py-3" data-id="element-69">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-70">
        <ol className="flex items-center flex-wrap gap-2 text-xs font-bold uppercase tracking-wider" data-id="element-71">
          {allItems.map((item, index) => {
          const isLast = index === allItems.length - 1;
          return <li key={index} className="flex items-center" data-id="element-72">
                {index > 0 && <ChevronRight className="w-3 h-3 text-steel-400 mx-2 flex-shrink-0" data-id="element-73" />}

                {item.to && !isLast ? <Link to={item.to} className="text-steel-500 hover:text-cg-orange-600 transition-colors flex items-center gap-1" data-id="element-74">
                    {item.label === 'Home' && <Home className="w-3 h-3 mb-0.5" data-id="element-75" />}
                    {item.label !== 'Home' && item.label}
                  </Link> : <span className="text-navy-900" aria-current="page" data-id="element-76">
                    {item.label}
                  </span>}
              </li>;
        })}
        </ol>
      </div>
    </nav>;
}